import { parseDate } from 'global/Utility/TSFunctions';
import { Ibcbs_config_attribute_extended } from 'model/CRM.type';
import { IGLWindow } from 'model/GroupLibraryWindow';
import * as FAM from '../../model/FlexibleAttributeModel';
import { EHideReason } from './EHideReason';
import { IFieldReference } from './IFieldReference';
import { IVisibilityScope } from './IVisibilityScope.type';
import { ParentVisibilityGraphProcessor } from './ParentVisibilityGraph';

// TODO needs to be refactored to use cache and also should follow FieldsToLookupByMasterAttributeId pattern or use that as input
// TODO also needs to only work with changed fields if all calls allow for it, right now looks like it return everything going invisible
export function ApplyVisibilityFields(config: FAM.IGroupConfigurationConfig, fields: FAM.IFlexibleField[], scope: IVisibilityScope) {

    // const { configToFieldIx, masterConfigToFieldIx } = fieldsMap(config, fields);
    const fieldMapByConfigRefId = new Map<string, IFieldReference>();
    const hiddenFieldMapByConfigRefId = new Map<string, IFieldReference>();

    fields.forEach((eField, eachFieldIndex) => {

        const attribute = config.cache.map_bcbs_config_attribute[eField.configRef.id] as Ibcbs_config_attribute_extended;

        if (!attribute) {
            console.warn("[visi] GlobalVisibility.ApplyVisibilityFields", 'missing-attribute', eField.configRef.id)
            return;
        }

        const masterAttribute = config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
        if (!masterAttribute) {
            console.warn("[visi] GlobalVisibility.ApplyVisibilityFields", 'missing-master-attribute', attribute._bcbs_config_masterattributeid_value)
            return;
        }

        const eFieldReference = {
            index: eachFieldIndex,
            field: eField,
            attribute: attribute,
            masterAttribute: masterAttribute,
        };

        // map all the fields by their attribute id so we can get the value
        fieldMapByConfigRefId.set(eField.configRef.id, eFieldReference);

        const attributeVisibility = attribute.visibility;

        if (!attributeVisibility) {
            console.warn("[visi] GlobalVisibility.ApplyVisibilityFields", 'missing-visibility-attributes', eField.configRef.id)
            return;
        }

        // if (attribute.bcbs_config_attributeid === '5d1b4bb4-720f-ee11-8f6d-000d3a305861'){
        //     debugger;
        // }

        const attribute_operative_effectiveDate = attributeVisibility.effectiveDate;
        const attribute_operative_ExpirationDate = attributeVisibility.expirationDate;
        const attribute_effective_effectiveDate = attributeVisibility.effective_effectiveDate
        const attribute_effective_expirationDate = attributeVisibility.effective_expirationDate;

        let visibility = EHideReason.Visible;

        // Effective Effective Date
        if (attribute_effective_effectiveDate > 0 && scope.effectiveDate > 0 && attribute_effective_effectiveDate > scope.effectiveDate)
            visibility = visibility | EHideReason.EffectiveDate;
        else if (attribute_operative_effectiveDate > 0 && scope.operativeDate > 0 && attribute_operative_effectiveDate > scope.operativeDate)
            visibility = visibility | EHideReason.EffectiveDate;
        else
            visibility = visibility & ~(EHideReason.EffectiveDate);

        // Effective Expiration Date
        if (attribute_effective_expirationDate > 0 && scope.effectiveDate > 0 && attribute_effective_expirationDate < scope.effectiveDate)
            visibility = visibility | EHideReason.ExpirationDate;
        else if (attribute_operative_ExpirationDate > 0 && scope.operativeDate > 0 && attribute_operative_ExpirationDate < scope.operativeDate)
            visibility = visibility | EHideReason.ExpirationDate;
        else
            visibility = visibility & ~(EHideReason.ExpirationDate);

        // // if on the config, they have picked Effective Date(808900001) as the rule
        // if (attribute.bcbs_enablebasedoncode === IXrmOptions.bcbs_config_attribute.bcbs_enablebasedoncode['Effective Date(808900001)'].value) {
        // } else {
        //     // attribute.bcbs_enablebasedoncode === null 
        //     // attribute.bcbs_enablebasedoncode === undefined 
        //     // attribute.bcbs_enablebasedoncode === IXrmOptions.bcbs_config_attribute.bcbs_enablebasedoncode['Created On(808900000)'].value 
        //     // Effective Date
        //     // Expiration Date
        // }

        // Funding Type
        if (scope.fundingType !== null)
            if (!attributeVisibility?.fundingType?.[scope.fundingType])
                visibility = visibility | EHideReason.fundingType;
            else
                visibility = visibility & ~(EHideReason.fundingType);

        // Grand Fathered
        // apply only if applicable:
        // for some benefit categories e.x. Vision, if it is set to not enabled grandfather, this check needs to ignore
        if (scope.grandFathered !== null)
            if (!attributeVisibility?.grandFathered?.[scope.grandFathered])
                visibility = visibility | EHideReason.grandFathered;
            else
                visibility = visibility & ~(EHideReason.grandFathered);

        // Erisa
        if (scope.erisa !== null)
            if (!attributeVisibility?.erisa?.[scope.erisa])
                visibility = visibility | EHideReason.erisa;
            else
                visibility = visibility & ~(EHideReason.erisa);

        // lineOfBusiness
        if (scope.lineOfBusiness !== null)
            if (!attributeVisibility?.lineOfBusiness?.[scope.lineOfBusiness])
                visibility = visibility | EHideReason.lineOfBusiness;
            else
                visibility = visibility & ~(EHideReason.lineOfBusiness);

        if (visibility) {
            eField.visibility = visibility;

            // clear values
            eField.values.forEach(eachFieldValue => {
                eachFieldValue.value = null;
            });

            hiddenFieldMapByConfigRefId.set(eField.configRef.id, eFieldReference);
        }
        else {
            delete eField.visibility
        }

    });


    const graphProcessor = new ParentVisibilityGraphProcessor(config, config.cache.parentVisibilityGraph);
    const graphChange = graphProcessor.processVisibilityForContext(fieldMapByConfigRefId);
    graphChange.forEach(eachChange => {
        if (eachChange.newVisibility) {

            const eField = fields[eachChange.index];
            eField.visibility = eachChange.newVisibility;

            // if for any reason it is hidden, remove the values
            eField.values.forEach(eachFieldValue => {
                eachFieldValue.value = null;
            });

            hiddenFieldMapByConfigRefId.set(eField.configRef.id, eachChange);
        }
        else
            delete fields[eachChange.index].visibility;
    });

    return hiddenFieldMapByConfigRefId;
}


/**
 * 
 * @param originatingScope context scope that this function will try to build on
 * @param groupConfiguration parent json
 * @param benefit inside a benefit context, otherwise null
 * @param plan inside a plan context, otherwise null
 * @returns 
 */
export function BuildVisibilityScope(
    originatingScope: IVisibilityScope | null,
    groupConfiguration: FAM.IGroupConfigurationData,
    benefit: FAM.IBenefit | null | undefined,
    plan: FAM.IPlan | null | undefined,
): IVisibilityScope {

    // created-on on replaced effective-date (data.effectiveDate?.value)
    // it was decided to switch to operativeDate which closely follows created on.
    // instead of created on a place holder called operativeDate was implemented.

    // we start from group configuration and gradually build scope
    const retScope: IVisibilityScope = originatingScope
        ? { ...originatingScope }
        : {
            operativeDate: groupConfiguration.operativeDate?.value
                ? parseDate(groupConfiguration.operativeDate.value, 'local:yyyy-MM-dd').getTime()
                : 0,
            effectiveDate: groupConfiguration.effectiveDate?.value
                ? parseDate(groupConfiguration.effectiveDate.value, 'local:yyyy-MM-dd').getTime()
                : 0,
            fundingType: groupConfiguration.fundingType?.value ?? 0,
            erisa: groupConfiguration.erisa?.value ?? 0,
            lineOfBusiness: groupConfiguration.lineOfBusiness?.value ?? 0,
            grandFathered: groupConfiguration.grandFathered?.value ?? 0,
            product: false,
        };

    if (plan) {
        retScope.fundingType = plan.fundingType?.value ?? retScope.fundingType;
        retScope.grandFathered = plan.grandFathered?.value ?? retScope.fundingType;
    }

    if (benefit) {
        retScope.fundingType = benefit.fundingType?.value ?? retScope.fundingType;

        if (benefit.grandFathered?.value)
            retScope.grandFathered = benefit.grandFathered?.value;

        if (benefit.product?.value)
            retScope.product = benefit.product?.value === FAM.EProduct.Yes
    }

    return retScope;
}

export const applyVisibilityGroupConfiguration = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    scope: IVisibilityScope,
    groupConfiguration: FAM.IGroupConfigurationData
) => {

    ApplyVisibilityFields(config, groupConfiguration.fields, scope);

    groupConfiguration.nonStandards.forEach(eachNonStandard => {
        ApplyVisibilityFields(config, eachNonStandard.fields, scope);
    });

}


export const applyVisibilityPlan = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    scope: IVisibilityScope,
    plans: FAM.IPlan[],
) => {

    plans.forEach(e => {
        const _scopeVisibility = BuildVisibilityScope(scope, data, null, e);

        ApplyVisibilityFields(config, e.fields, _scopeVisibility);

        e.attributeSets?.forEach(e2 => {
            ApplyVisibilityFields(config, e2.fields, _scopeVisibility)
        })
    })
}


export const applyVisibilityBenefit = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    scope: IVisibilityScope,
    benefits: FAM.IBenefit[],
) => {

    benefits.forEach(eBenefit => {

        const benefitScope = BuildVisibilityScope(
            scope,
            data,
            eBenefit,
            null
        );

        const hiddenFieldMapByConfigRefId = ApplyVisibilityFields(config, eBenefit.fields, benefitScope);

        applyVisibilityAttributeSets(data, config, benefitScope, eBenefit.attributeSets, hiddenFieldMapByConfigRefId)

        eBenefit.nonStandards.forEach(eNonStandards => {
            ApplyVisibilityFields(config, eNonStandards.fields, benefitScope)
        })
    });
}

export const applyVisibilityAttributeSets = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    scope: IVisibilityScope,
    attributeSets: FAM.IFlexibleFieldSet[],
    parentHiddenFieldsByConfigRefId: Map<string, IFieldReference>

) => {

    var i = attributeSets.length;
    while (i-- > 0) {
        const eAttributeSets = attributeSets[i];

        const configAttributes = config.cache.map_bcbs_config_attribute_by_masterAttributeId[eAttributeSets.attributeSetRef.id];

        // any hidden ?
        const configAttributesThatAreHidden = configAttributes
            .map(t => parentHiddenFieldsByConfigRefId.get(t.bcbs_config_attributeid!))
            .filter(t => !!t);

        // This technically should almost always yield to a single attribute describing where the attribute is rendered
        if (configAttributesThatAreHidden.length > 0 && configAttributes.length === configAttributesThatAreHidden.length) {
            // eAttributeSets.deactivated = true;
            attributeSets.splice(i, 1);
        }
        else {
            ApplyVisibilityFields(config, eAttributeSets.fields, scope)
        }
    }
}

export const applyVisibilityNonstandard = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    scope: IVisibilityScope | null,
    benefit: FAM.IBenefit | null,
    nonStandard: FAM.INonStandard,
) => {

    const benefitScope = BuildVisibilityScope(
        scope,
        data,
        benefit,
        null
    );

    ApplyVisibilityFields(config, nonStandard.fields, benefitScope);
}

export const applyVisibilityNonstandardTemplate = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    scope: IVisibilityScope | null,
    benefit: FAM.IBenefit | null,
    nonStandardTemplate: FAM.INonStandardTemplate,
) => {

    const benefitScope = BuildVisibilityScope(
        scope,
        data,
        null,
        null
    );
    ApplyVisibilityFields(config, nonStandardTemplate.fields, benefitScope);
}

export const applyVisibilityFeesAndPremiums = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    scope: IVisibilityScope,
    feesAndPremiums: FAM.IFeesAndPremiums[],
) => {

    feesAndPremiums.forEach(eFeesAndPremium => {
        const hiddenFieldMapByConfigRefId = ApplyVisibilityFields(config, eFeesAndPremium.fields, scope);
        applyVisibilityAttributeSets(data, config, scope, eFeesAndPremium.attributeSets, hiddenFieldMapByConfigRefId)
    });
}

export const applyVisibilityStopLosses = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    scope: IVisibilityScope,
    stopLosses: FAM.IStopLoss[],
) => {
    stopLosses.forEach(eStopLoss => {
        const hiddenFieldMapByConfigRefId = ApplyVisibilityFields(config, eStopLoss.fields, scope);
        applyVisibilityAttributeSets(data, config, scope, eStopLoss.attributeSets, hiddenFieldMapByConfigRefId)
    });
}

export const applyVisibilityAccountReceivables = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    scope: IVisibilityScope,
    accountReceivables: FAM.IAccountsReceivable[],
) => {

    accountReceivables.forEach(eAccountReceivable => {
        const hiddenFieldMapByConfigRefId = ApplyVisibilityFields(config, eAccountReceivable.fields, scope);
        applyVisibilityAttributeSets(data, config, scope, eAccountReceivable.attributeSets, hiddenFieldMapByConfigRefId)
    });
}

export const applyVisibility = (
    data: FAM.IGroupConfigurationData,
    config: FAM.IGroupConfigurationConfig,
    rules?: 'all' | 'parentVisibility',
    applyTo?: {
        groupConfiguration?: FAM.IGroupConfigurationData;
        benefit?: FAM.IBenefit;
        plan?: FAM.IPlan;
        feesAndPremium?: FAM.IFeesAndPremiums;
        groupNumber?: FAM.IGroupNumber;
        stopLoss?: FAM.IStopLoss;
        accountReceivable?: FAM.IAccountsReceivable;
    }
) => {

    console.log("[visi] GlobalVisibility.applyVisibility")

    if ((window as IGLWindow)?.debugOptions?.noVisibility) {
        console.warn("[visi] GlobalVisibility.applyVisibility", "eject-debug");
        return;
    }

    // Building Global Scope
    // ---------------------------------------------
    const scope: IVisibilityScope = BuildVisibilityScope(
        null,
        data,
        null,
        null
    );

    // Group Configuration
    // ---------------------------------------------
    let groupConfiguration: FAM.IGroupConfigurationData | null = data;

    if (applyTo?.groupConfiguration)
        groupConfiguration = applyTo.groupConfiguration;
    else if (applyTo)
        groupConfiguration = null;

    if (groupConfiguration) {
        applyVisibilityGroupConfiguration(data, config, scope, groupConfiguration);
    }

    // Plans
    // ---------------------------------------------
    let plans = data.plans;

    if (applyTo?.plan)
        plans = [applyTo.plan];
    else if (applyTo)
        plans = [];

    applyVisibilityPlan(data, config, scope, plans);


    // Benefits
    // ---------------------------------------------
    let benefits = data.benefits;

    if (applyTo?.benefit)
        benefits = [applyTo.benefit];
    else if (applyTo)
        benefits = [];

    applyVisibilityBenefit(data, config, scope, benefits);

    // Group Structure
    // ---------------------------------------------
    let groupNumbers = data.groupStructure.groupNumbers;

    if (applyTo?.groupNumber)
        groupNumbers = [applyTo?.groupNumber];
    else if (applyTo)
        groupNumbers = [];

    groupNumbers.forEach(e => {
        ApplyVisibilityFields(config, e.fields, scope);
    });

    // Fees And Premiums
    // ---------------------------------------------
    let feesAndPremiums = data.feesAndPremiums;

    if (applyTo?.feesAndPremium)
        feesAndPremiums = [applyTo.feesAndPremium];
    else if (applyTo)
        feesAndPremiums = [];

    applyVisibilityFeesAndPremiums(data, config, scope, feesAndPremiums);

    // Stop Loss
    // ---------------------------------------------
    let stopLosses = data.stopLoss;

    if (applyTo?.stopLoss)
        stopLosses = [applyTo.stopLoss];
    else if (applyTo)
        stopLosses = [];

    applyVisibilityStopLosses(data, config, scope, stopLosses);

    // Accounts Receivables
    // ---------------------------------------------
    let accountReceivables = data.claimsARs;

    if (applyTo?.accountReceivable)
        accountReceivables = [applyTo.accountReceivable];
    else if (applyTo)
        accountReceivables = [];

    applyVisibilityAccountReceivables(data, config, scope, accountReceivables);

}


